// TODO Not able to delete until removing common-back
export const TECH_SOURCES = [
    'manfred',
    'backoffice',
    'devStory',
    'linkedin'
];
// TODO Not able to delete until removing common-back
export const TECH_TYPES = ['discarded', 'pending', 'valid'];
// TODO Not able to delete until removing common-back
export var TechSourceEmum;
(function (TechSourceEmum) {
    TechSourceEmum["manfred"] = "manfred";
    TechSourceEmum["backoffice"] = "backoffice";
    TechSourceEmum["devStory"] = "devStory";
    TechSourceEmum["linkedin"] = "linkedin";
})(TechSourceEmum || (TechSourceEmum = {}));
// TODO Not able to delete until removing common-back
export var TechStatusEmum;
(function (TechStatusEmum) {
    TechStatusEmum["discarded"] = "discarded";
    TechStatusEmum["pending"] = "pending";
    TechStatusEmum["valid"] = "valid";
})(TechStatusEmum || (TechStatusEmum = {}));
//# sourceMappingURL=tech.interface.js.map